import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    children: PropTypes.node, // your icon element(s). eg <span className="fa fa-someicon" aria-hidden={true}/>
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    showLabelAsTitle: PropTypes.bool,
}

const defaultProps = {
    children: null,
    className: '',
    showLabelAsTitle: false,
};

function AccessibleIcon(props) {
    const attrs = {};
    if (props.showLabelAsTitle) attrs['title'] = props.label;

    return (
        <span className={props.className} {...attrs}>
            {props.children}
            <span className="sr-only">{props.label}</span>
        </span>
    );
}

AccessibleIcon.propTypes = propTypes;
AccessibleIcon.defaultProps = defaultProps;

export default AccessibleIcon;